module.exports = __webpack_public_path__ + "img/bw.378bc9f4.svg";